export default {"src":"/login-app/[GIT_HASH]/_next/static/media/smart_toy.ae220c48.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};